module.exports = require('./helpers/bundle-url').getBundleURL('kBjr5') + "DOT.7e599be5.svg";